<div class="sam-form-row">
   <label>{{ 'brick.brick_definitions.toolbar_brick.settings.presentation_type' | translate }}</label>
   <kendo-dropdownlist
      [data]="presentationTypePossibleValues"
      [value]="presentationType$ | async"
      class="k-form-field sam-form-control sam-form-control-full-width"
      [valuePrimitive]="false"
      [valueField]="'value'"
      [textField]="'value'"
      (selectionChange)="changePresentationType($event)"
   >
      <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
         {{ dataItem?.translationKey | translate }}
      </ng-template>
   </kendo-dropdownlist>
   <label *ngIf="isVerticalViewPossible" class="k-checkbox-label vertical-checkbox" for="selectView">
      <input
         type="checkbox"
         id="selectView"
         [checked]="showVertical$ | async"
         (click)="changeShowVertical($event.currentTarget.checked)"
         class="k-checkbox"
      />
      {{ 'brick.brick_definitions.toolbar_brick.settings.vertical' | translate }}
   </label>
</div>

<div class="row">
   <label [style.font-weight]="'bolder'">{{
      'brick.brick_definitions.toolbar_brick.settings.actions' | translate
   }}</label>

   <div
      class="scrollable"
      cdkDropList
      #actionList="cdkDropList"
      [cdkDropListData]="actionIds$ | async"
      (cdkDropListDropped)="onDrop($event)"
   >
      <ng-container *ngIf="(actionIds$ | async)?.length > 0; else emptyList">
         <kendo-panelbar fxFlex="1 1 100%" class="sam-panelbar-item">
            <kendo-panelbar-item title="" *ngFor="let item of actionIds$ | async">
               <ng-template kendoPanelBarItemTitle>
                  <div class="sam-full-width sam-center" fxLayout="row">
                     <samweb-toolbar-item-setting
                        class="sam-full-width sam-no-margin"
                        [brickInstanceId]="brickInstanceId"
                        [actionId]="item"
                        [toolbarId]="toolbarId"
                        [collapsed]="true"
                     >
                     </samweb-toolbar-item-setting>
                  </div>
               </ng-template>
               <ng-template kendoPanelBarContent>
                  <div class="sam-full-width">
                     <samweb-toolbar-item-setting
                        [brickInstanceId]="brickInstanceId"
                        [actionId]="item"
                        [toolbarId]="toolbarId"
                     ></samweb-toolbar-item-setting>
                  </div>
               </ng-template>
            </kendo-panelbar-item>
         </kendo-panelbar>
      </ng-container>
      <ng-template #emptyList>
         <div>{{ 'brick.brick_definitions.toolbar_brick.settings.no_actions' | translate }}</div>
      </ng-template>
   </div>
</div>

<div fxLayout="row">
   <button (click)="addNewAction()" kendoTooltip kendoButton>
      <fa-icon class="sam-margin-right" [icon]="addTabIcon"></fa-icon>
      <div class="sam-button-text">
         {{ 'brick.brick_definitions.toolbar_brick.settings.new_action_button' | translate }}
      </div>
   </button>
</div>
